export const VIEW_PATHS = {
  perfil: 'perfil',
  usuarios: 'usuarios',
  programa: 'programa',
  interacciones: 'interacciones',
  actividades: 'actividades',
  roles: 'roles',
  bonda: 'bonda',
  canje: 'canje',
  never: 'sin-acceso'
};

export const AUTH_PATHS = {
  login: 'login',
  createAccount: 'registrarse',
  forgotPassword: 'recuperar-contrasena',
  resetPassword: 'cambiar-contrasena'
};

export const PATH_VIEWS = Object.entries(VIEW_PATHS).reduce((acc, [view, path]) => {
  acc[path] = view;
  return acc;
}, {});

export const PATH_AUTH_VIEWS = Object.entries(AUTH_PATHS).reduce((acc, [view, path]) => {
  acc[path] = view;
  return acc;
}, {});

const VIEW_PERMISSIONS = {
  perfil: 0,
  usuarios: 1,
  interacciones: 2,
  actividades: 3,
  roles: 4,
  programa: 6,
  bonda: 5
};

export const getViewFromLocation = () => {
  const path = window.location.pathname.replace(/\/+$/, '');
  const parts = path.split('/').filter(Boolean);
  if (parts.length !== 1) return null;
  return PATH_VIEWS[parts[0]] || null;
};

export const getAuthViewFromLocation = () => {
  const path = window.location.pathname.replace(/\/+$/, '');
  const parts = path.split('/').filter(Boolean);
  if (parts.length !== 1) return null;
  return PATH_AUTH_VIEWS[parts[0]] || null;
};

export const pathForView = (view) => `/${VIEW_PATHS[view] || VIEW_PATHS.perfil}`;

export const pathForAuthView = (view) => `/${AUTH_PATHS[view] || AUTH_PATHS.login}`;

export const replaceWithLogin = () => {
  window.history.replaceState({}, '', pathForAuthView('login'));
};

export const syncUrlForView = (view, replace = false) => {
  const path = pathForView(view);
  if (window.location.pathname === path) return;
  const method = replace ? 'replaceState' : 'pushState';
  window.history[method]({}, '', path);
};

export const syncUrlForAuthView = (view, replace = false) => {
  const path = pathForAuthView(view);
  const search = view === 'resetPassword' ? window.location.search : '';
  if (window.location.pathname === path && window.location.search === search) return;
  const method = replace ? 'replaceState' : 'pushState';
  window.history[method]({}, '', `${path}${search}`);
};

export const canAccessView = (view, permissions = []) => {
  if (!view) return false;
  if (view === 'canje') return true;
  if (view === 'never') return true;
  const permission = VIEW_PERMISSIONS[view];
  if (permission === undefined) return false;
  return permissions.includes(permission);
};

export const defaultViewForPermissions = (permissions = []) => {
  let view = 'never';
  if (permissions.includes(3)) view = 'actividades';
  if (permissions.includes(2)) view = 'interacciones';
  if (permissions.includes(4)) view = 'roles';
  if (permissions.includes(1)) view = 'usuarios';
  if (permissions.includes(0)) view = 'perfil';
  if (permissions.includes(6) && !permissions.includes(18)) view = 'programa';
  return view;
};
